import * as $ from 'jquery';

const oldjquery = (window as any).jQuery;
(window as any).jQuery = $;
import './jquery.Jcrop';
(window as any).jQuery = oldjquery;


// WEBPACK FOOTER //
// ./lib/jcrop-loader.ts